import React from 'react'
import './Header.css';

function Header() {
  return (
    <header>
        <div className='container'>
        <div className='hero'>
          
            <h1>Order your <br/> favourite food here</h1>
            <p>Craving something delicious? We’ve got you covered! With fast, reliable delivery and a wide selection of mouthwatering dishes from your favorite local restaurants, getting your next meal has never been easier. Order now and experience the convenience of food delivered exactly when you need it.</p>
            <div>
            <button className='view_menu'>View menu</button>
          </div>
        </div>
        </div>
    </header>
  )
}

export default Header